// extracted by mini-css-extract-plugin
export default {"switch__container":"RequesteeSearch_switch__container__vo6tf","footer":"RequesteeSearch_footer__e8FOJ","body__container":"RequesteeSearch_body__container__dM5tR"};